/** The P9 reveal header (screens §P9.1), shared with the practice result: a navy hero: the Results headline alone, or (the practice result) two blocks, the score on the left and what explains it on the right. */
import type { ReactNode } from "react";
import "./results.css";

export function RevealHeader({ lead, aside = null, reveal = false, testId = "results.hero", watermark }: {
  readonly lead: ReactNode; /** Left out, the hero is one block (the Results headline). */ readonly aside?: ReactNode; readonly reveal?: boolean; readonly testId?: string;
  /** A word drawn faintly inside the card ("Practice"), so it never sits over the page or the chips above. */
  readonly watermark?: string;
}) {
  return (
    <section className={`gx-hero gx-on-navy gx-results-hero${aside === null ? " gx-results-hero--single" : ""}${reveal ? " gx-results-reveal" : ""}`} data-testid={testId}>
      <div>{lead}</div>
      {aside === null ? null : <div>{aside}</div>}
      {watermark === undefined ? null : <span className="gx-watermark" aria-hidden="true">{watermark}</span>}
    </section>
  );
}
